function getDocument(element) {
  return element ? element.ownerDocument || element : document;
}

export { getDocument };